export function addEventListenerOnce(
  selector: string | Window,
  type: string,
  listener: EventListenerOrEventListenerObject,
) {
  const isWindow = window && window.self === selector;

  if (isWindow) {
    selector.addEventListener(type, listener);
  } else if (typeof selector === 'string') {
    const ele = document.querySelector(selector);

    if (ele && ele.getAttribute('data-checkout-loaded') !== 'true') {
      ele.addEventListener(type, listener);
      ele.setAttribute('data-checkout-loaded', 'true');
    }
  }
}
